import { Globals } from "../CoreApp/Globals";

export function updateXMLRenderStatus() {
  var g = Globals._bookRenderInfo;
  var pp = g.fPubPanel;
  //var bookType = pp.GetBookType();
  //var isXML = bookType == enumBookType.xml;
  var pmsg = null;
  var workingPage = g.fWorkingPage;
  if (typeof workingPage == "string") {
    workingPage = parseInt(workingPage.substring(1)) + g.fBranchPages;
  }

  pp.UpdateProgress(pmsg, workingPage + 1, g.fNumPages);
}
